// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MenuSidebar_menuSidebar__a09V9 {
  display: flex;
  flex-direction: column;
  padding: 20px 30px;
  justify-content: space-between;
  box-sizing: border-box;
  height: 100%;
  gap: 50px;
}
.MenuSidebar_menuSidebar__a09V9 a {
  text-decoration: none;
}
.MenuSidebar_menuSidebar__a09V9 a button {
  font-size: 20px;
  font-weight: 300;
}
.MenuSidebar_menuSidebar__a09V9 a button:hover {
  text-decoration: none;
}
.MenuSidebar_menuSidebar__a09V9 .MenuSidebar_top__CPciO {
  display: flex;
  flex-direction: column;
  gap: 50px;
}
.MenuSidebar_menuSidebar__a09V9 .MenuSidebar_top__CPciO .MenuSidebar_containers__c\\+5fy {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.MenuSidebar_menuSidebar__a09V9 .MenuSidebar_top__CPciO .MenuSidebar_header__C7Pyl {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.MenuSidebar_menuSidebar__a09V9 .MenuSidebar_bottom__VhPuw {
  display: flex;
  flex-direction: column;
  gap: 50px;
}
.MenuSidebar_menuSidebar__a09V9 .MenuSidebar_bottom__VhPuw .MenuSidebar_footer__9J3UQ {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
}
.MenuSidebar_menuSidebar__a09V9 .MenuSidebar_bottom__VhPuw .MenuSidebar_footer__9J3UQ .MenuSidebar_copyright__sk0VF {
  text-transform: uppercase;
  font-size: 12px;
}

.MenuSidebar_menuIcon__\\+N0Uy {
  height: 16px !important;
  width: 16px !important;
}

.MenuSidebar_closeButton__dxeYV {
  margin-right: -20px;
}

.MenuSidebar_link__KLioZ {
  display: flex;
  color: white;
  font-weight: 200;
  font-size: 18px;
  margin-top: 10px;
  margin-bottom: 10px;
  gap: 12px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/MenuSidebar/MenuSidebar.module.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,8BAAA;EACA,sBAAA;EACA,YAAA;EACA,SAAA;AAFF;AAIE;EACE,qBAAA;AAFJ;AAII;EACE,eAAA;EACA,gBAAA;AAFN;AAIM;EACE,qBAAA;AAFR;AAOE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AALJ;AAOI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AALN;AAQI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AANN;AAUE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AARJ;AAUI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AARN;AAUM;EACE,yBAAA;EACA,eAAA;AARR;;AAcA;EACE,uBAAA;EACA,sBAAA;AAXF;;AAcA;EACE,mBAAA;AAXF;;AAcA;EACE,aAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;AAXF","sourcesContent":["@import '@common/scss/_colors';\n@import '@common/scss/_variables';\n\n.menuSidebar {\n  display: flex;\n  flex-direction: column;\n  padding: $padding-l $padding-xl;\n  justify-content: space-between;\n  box-sizing: border-box;\n  height: 100%;\n  gap: 50px;\n\n  a {\n    text-decoration: none;\n\n    button {\n      font-size: 20px;\n      font-weight: 300;\n\n      &:hover {\n        text-decoration: none;\n      }\n    }\n  }\n\n  & .top {\n    display: flex;\n    flex-direction: column;\n    gap: 50px;\n\n    & .containers {\n      display: flex;\n      flex-direction: column;\n      gap: 30px;\n    }\n\n    & .header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n    }\n  }\n\n  & .bottom {\n    display: flex;\n    flex-direction: column;\n    gap: 50px;\n\n    & .footer {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      gap: 20px;\n\n      & .copyright {\n        text-transform: uppercase;\n        font-size: 12px;\n      }\n    }\n  }\n}\n\n.menuIcon {\n  height: 16px !important;\n  width: 16px !important;\n}\n\n.closeButton {\n  margin-right: -20px;\n}\n\n.link {\n  display: flex;\n  color: white;\n  font-weight: 200;\n  font-size: 18px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  gap: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menuSidebar": `MenuSidebar_menuSidebar__a09V9`,
	"top": `MenuSidebar_top__CPciO`,
	"containers": `MenuSidebar_containers__c+5fy`,
	"header": `MenuSidebar_header__C7Pyl`,
	"bottom": `MenuSidebar_bottom__VhPuw`,
	"footer": `MenuSidebar_footer__9J3UQ`,
	"copyright": `MenuSidebar_copyright__sk0VF`,
	"menuIcon": `MenuSidebar_menuIcon__+N0Uy`,
	"closeButton": `MenuSidebar_closeButton__dxeYV`,
	"link": `MenuSidebar_link__KLioZ`
};
export default ___CSS_LOADER_EXPORT___;
